import { gql } from "@apollo/client";

export const SAVE_ULTIMO_PASO_INDEX = gql`
  mutation saveUltimoPasoIndex($idVisita: Int!, $pasoIndex: Int!) {
    saveUltimoPasoIndex(idVisita: $idVisita, pasoIndex: $pasoIndex) 
  }
`;